export default "__VITE_PUBLIC_ASSET__de1761dc__"